<script>
  import { navigate } from 'svelte-routing';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { authFetch } from '../authService'; // <-- IMPORT THIS

  let title = '';
  let description = '';
  let price = 0;
  let type = 'Digital'; // Digital, Physical
  let delivery = 'Online'; // Online, InPerson, Post
  let secretContent = '';
  let images = []; // base64 strings
  
  let isSubmitting = false;
  let currentUser;
  authStore.subscribe(v => currentUser = v.user);

  function handleFile(e) {
      if (e.target.files.length + images.length > 2) {
          alert("Max 2 images."); return;
      }
      for (let file of e.target.files) {
          const reader = new FileReader();
          reader.onload = () => images = [...images, reader.result.split(',')[1]];
          reader.readAsDataURL(file);
      }
  }

  async function handleSubmit() {
      isSubmitting = true;
      const payload = {
          sellerId: currentUser.idTokenClaims.oid,
          title, description, price: parseInt(price),
          type, delivery, secretContent,
          imageBase64s: images
      };
      
      try {
          const res = await authFetch(getApiUrl('/marketplace/items'), {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(payload)
          });
          if(res.ok) navigate('/marketplace');
          else alert("Failed to list item");
      } catch(e) { console.error(e); } 
      finally { isSubmitting = false; }
  }
</script>

<div class="form-container">
    <h2>Sell an Item</h2>
    <form on:submit|preventDefault={handleSubmit}>
        <div class="group"><label>Title</label><input type="text" bind:value={title} required /></div>
        <div class="group"><label>Description</label><textarea bind:value={description} required></textarea></div>
        <div class="row">
            <div class="group"><label>Price (Credits)</label><input type="number" bind:value={price} min="0" required /></div>
            <div class="group"><label>Type</label>
                <select bind:value={type}>
                    <option>Digital</option><option>Physical</option>
                </select>
            </div>
            <div class="group"><label>Delivery</label>
                <select bind:value={delivery}>
                    <option>Online</option><option>InPerson</option><option>Post</option>
                </select>
            </div>
        </div>
        
        <div class="group">
            <label>Secret Content / Instructions</label>
            <p class="hint">For Digital: Enter code/link. For Physical: Enter contact info for handover.</p>
            <textarea bind:value={secretContent} required placeholder="This will only be revealed to the buyer."></textarea>
        </div>

        <div class="group">
            <label>Images (Max 2)</label>
            <input type="file" multiple accept="image/*" on:change={handleFile} />
            <div class="previews">
                {#each images as img}<img src={`data:image/jpeg;base64,${img}`} class="thumb" alt="preview"/>{/each}
            </div>
        </div>

        <button type="submit" disabled={isSubmitting}>{isSubmitting ? 'Posting...' : 'List Item'}</button>
    </form>
</div>

<style>
    .form-container { max-width: 600px; margin: 2rem auto; padding: 2rem; background: white; border-radius: 8px; }
    .group { margin-bottom: 1rem; }
    .row { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem; }
    label { display: block; font-weight: 500; margin-bottom: 0.5rem; }
    input, textarea, select { width: 100%; padding: 0.75rem; border: 1px solid #ccc; border-radius: 4px; box-sizing: border-box; }
    .hint { font-size: 0.85rem; color: #666; margin: 0 0 0.5rem 0; }
    .thumb { height: 80px; margin-right: 10px; border-radius: 4px; }
    button { width: 100%; padding: 1rem; background: #007bff; color: white; border: none; cursor: pointer; }
</style>